/**
 * Module Configuration
 * Defines all modules available in the admin panel for ACM
 * IMPORTANT: paths and routes must match actual routes in routes/index.js
 */

export const MODULES = {
  DASHBOARD: {
    id: 'DASHBOARD',
    name: 'Dashboard',
    icon: 'bx-home-circle',
    path: '/dashboard',
    routes: ['/dashboard'],
  },

  FOOD: {
    id: 'FOOD',
    name: 'Food Management',
    icon: 'bx-food-menu',
    path: '/Food',
    routes: [
      '/Food',
      '/Foodcuisine',
      '/FoodAddOn',
      '/FoodSettings',
      '/FoodOrder',
    ],
  },

  ROOM: {
    id: 'ROOM',
    name: 'Room Management',
    icon: 'bx-door-open',
    path: '/Room',
    routes: [
      '/Room',
      '/RoomType',
      '/RoomFeature',
      '/RoomHospitalityService',
      '/Booking',
      '/RoomCancel',
      '/AmenityType',
      '/Amenities',
    ],
  },

  AMENITY: {
    id: 'AMENITY',
    name: 'Amenity Management',
    icon: 'bx-spa',
    path: '/AmenityType',
    routes: [
      '/AmenityType',
      '/Amenities',
    ],
  },

  TABLE: {
    id: 'TABLE',
    name: 'Table Management',
    icon: 'bx-table',
    path: '/Table',
    routes: [
      '/Table',
      '/TableBooking',
      '/outlets',
    ],
  },

  TRANSPORTATION: {
    id: 'TRANSPORTATION',
    name: 'Transportation',
    icon: 'bx-car',
    path: '/transport/requests',
    routes: ['/transport'],
  },

  TAXI: {
    id: 'TAXI',
    name: 'Taxi Service',
    icon: 'bx-taxi',
    path: '/Taxi',
    routes: ['/Taxi'],
  },

  USERS: {
    id: 'USERS',
    name: 'User Management',
    icon: 'bx-user',
    path: '/User',
    routes: ['/User', '/DeliveryBoy'],
  },

  CROSSSELL: {
    id: 'CROSSSELL',
    name: 'Cross-sell Offers',
    icon: 'bx-purchase-tag',
    path: '/crosssell',
    routes: ['/crosssell'],
  },

  LOYALTY: {
    id: 'LOYALTY',
    name: 'Loyalty Program',
    icon: 'bx-gift',
    path: '/loyalty/accounts',
    routes: ['/loyalty'],
  },

  CHAT: {
    id: 'CHAT',
    name: 'Chat',
    icon: 'bx-chat',
    path: '/ChatList',
    routes: ['/ChatList'],
  },

  NOTIFICATION: {
    id: 'NOTIFICATION',
    name: 'Notifications',
    icon: 'bx-bell',
    path: '/Notification',
    routes: ['/Notification', '/ManageNotification'],
  },

  COUPON: {
    id: 'COUPON',
    name: 'Coupon Management',
    icon: 'bx-purchase-tag',
    path: '/coupon',
    routes: ['/coupon'],
  },

  BANNER: {
    id: 'BANNER',
    name: 'Banner Management',
    icon: 'bx-image',
    path: '/banner',
    routes: ['/banner'],
  },

  ATTRACTION: {
    id: 'ATTRACTION',
    name: 'Attractions',
    icon: 'bx-map-pin',
    path: '/Attraction',
    routes: ['/Attraction'],
  },

  PAYMENTS: {
    id: 'PAYMENTS',
    name: 'Payments & Transactions',
    icon: 'bx-credit-card',
    path: '/payments/transactions',
    routes: ['/payments'],
  },

  ANALYTICS: {
    id: 'ANALYTICS',
    name: 'Analytics & Reports',
    icon: 'bx-bar-chart-alt-2',
    path: '/analytics',
    routes: ['/analytics', '/activity-logs'],
  },

  BRANCH: {
    id: 'BRANCH',
    name: 'Branch Management',
    icon: 'bx-store',
    path: '/branches',
    routes: ['/branches', '/master-catalog'],
    superAdminOnly: true,
  },

  TEAM: {
    id: 'TEAM',
    name: 'Team Management',
    icon: 'bx-group',
    path: '/team',
    routes: ['/team'],
    // Permission-gated (NOT super-admin-only): a branch admin granted the TEAM
    // permission can manage their OWN branch's staff (server-enforced scope).
  },

  SETTINGS: {
    id: 'SETTINGS',
    name: 'Settings',
    icon: 'bx-cog',
    path: '/FoodSettings',
    routes: ['/FoodSettings'],
  },
};

/**
 * Get module by route path
 * @param {string} path - Current route path
 * @returns {object|null} Module object or null
 */
export const getModuleByRoute = (path) => {
  // Normalize path for comparison (case-insensitive for first character)
  const normalizedPath = path.toLowerCase();

  for (const moduleId in MODULES) {
    const module = MODULES[moduleId];
    if (module.routes.some((route) => normalizedPath.startsWith(route.toLowerCase()))) {
      return module;
    }
  }
  return null;
};

/**
 * Get all module IDs
 * @returns {string[]} Array of module IDs
 */
export const getAllModuleIds = () => {
  return Object.keys(MODULES);
};

/**
 * Get modules for permission checkboxes (excludes TEAM for non-super admins)
 * @param {boolean} includeSuperAdminOnly - Include super admin only modules
 * @returns {object[]} Array of module objects
 */
export const getModulesForPermissions = (includeSuperAdminOnly = false) => {
  return Object.values(MODULES).filter((module) => {
    if (module.superAdminOnly && !includeSuperAdminOnly) {
      return false;
    }
    return true;
  });
};

export default MODULES;
